(function() {

  'use strict';

  function EncomendaCtrl($scope, $rootScope, $log, $state, $filter, $uibModal, $timeout, localStorageService, Endereco, Pedido, Encomenda, Auth, Perfil) {
    // captura o escopo
    const vm = this;

    //Controle de visualização de campos e botões.
    vm.freedom = Perfil.getCacheUserData().freedom;
    vm.isCepPreenchido = false;
    vm.podeEscolherFormaEnvio = false;
    vm.podeAdicionarRemessa = false;
    vm.utilizarServicoOpcional = false;

    vm.isEdicao = ($state.current.name === 'editar');

    // se o retorno da busca de servico de envio nao trouxe prazos
    vm.servicoSemPrazo = false;
    vm.exibeLoadingNovaBusca = false;
    vm.buscaTipoServico = false;

    vm.showSedex10Message = false;

    // Se usuario alterou algum dado que veio dos correios.
    vm.alterouEnderecoCorreios = false;
    let enderecoCorreios = null;

    vm.getEncomenda = Encomenda.getEncomenda;

    vm.tiposEntrega = [];

    // flag para não bloquear modo normal
    vm.naoDesabilita = true;

    vm.showOutrosValores = false;

    vm.exibeErroBuscaServicos = false;
    vm.backendErrors = [];

    vm.checkTenhoNF = {
      value: vm.freedom
    };

    vm.checkNaoQueroEconomizar = {
      value: false
    };

    vm.user = JSON.parse(localStorage.getItem('ls.user'));
    Perfil.getClienteData(vm.user.id).then(function(user) {
      vm.user = user;
    });

    function getActivation() {
      const valorDeclaradoDefault = _.get(vm.getEncomenda(), 'valorDeclarado', null);
      if(!vm.isEdicao && (valorDeclaradoDefault > 0 || valorDeclaradoDefault === null)) {
        return true;
      } else if(vm.isEdicao && (valorDeclaradoDefault > 0)){
        return true;
      } else {
        return false;
      }
    }

    vm.desejaContratarSeguro = {
      value: getActivation()
    };
    /** FINAL TOTAL EXPRESS **/

    // Anula a imagem do serviço na etiqueta.
    $rootScope.$broadcast('etiqueta:destinatario:alterado', null);
    $rootScope.$broadcast('etiqueta:formaEnvio:alterada', null);

    vm.valorDeclaradoAdicional = null;

    // exibição do icone de search no form de busca
    vm.buscandoOn = true;

    // variaveis de focus
    vm.ruaOn = null;
    vm.numeroOn = null;
    vm.complementoOn = null;

    vm.isPJ = Auth.isPJ();

    let showTourTelefone;

    vm.habilitaImporCorreios = false;
    Perfil.getBetaFeatures()
      .then(function (data) {
        const permissoes = data.funcionalidades;
        const feature = _.find(permissoes, function (funcionalidade) { return funcionalidade.codigo === 'impor_correios'; });
        if (feature.possuiAcesso) {
          vm.habilitaImporCorreios = true;
        }
      })
      .catch(function (err) {
        console.log(err);
      });

    // função que busca os endereços no back
    vm.getLocation = function(address) {
      vm.buscandoOn = false;
      if (!isNaN(address.replace('-', ''))) {
        address = address.replace("-", "");
      };
      return Endereco.getAddress(address.toLowerCase())
        .then(function(data) {
          vm.buscandoOn = true;
          // reseta variaveis de focus
          vm.ruaOn = null;
          vm.numeroOn = null;
          vm.complementoOn = null;

          if (data.usouSugestao) {
            const sugestao = data.enderecosEncontrados;
            const obj = {
              'enderecoFormatado': 'Se você não encontrou o endereço, busque pelo CEP',
              'desabilita': true
            };
            sugestao.unshift(obj);
            return sugestao;
          } else {
            return data.enderecosEncontrados;
          }
        })
        .catch(function(err) {
          vm.buscandoOn = true;
          const erroFormatado = [{ 'enderecoFormatado': err.data.erro, 'desabilita': true }];

          return erroFormatado;
        });
    };

    vm.formatCep = function(cep) {
      return $filter('cep')(cep);
    }

    // função chamada quando o item é escolhido
    vm.preencheEndereco = function(item, model, label, event) {
      if (item.desabilita) {
        vm.getEncomenda().destinatario.endereco.cep = null;
      } else {
        if (!item.logradouro) {
          vm.ruaOn = true;
        } else if (!item.numero) {
          vm.numeroOn = true;
        } else {
          vm.complementoOn = true;
        }

        // Guarda endereço correios para comparação futura, se o usuario
        // alterou algum dos dados.
        enderecoCorreios = item;

        vm.isCepPreenchido = true;

        vm.getEncomenda().destinatario.endereco.cep = item.cep;
        vm.getEncomenda().destinatario.endereco.logradouro = item.logradouro;
        vm.getEncomenda().destinatario.endereco.numero = item.numero ? item.numero : null;
        vm.getEncomenda().destinatario.endereco.bairro = item.bairro;
        vm.getEncomenda().destinatario.endereco.cidade = item.cidade;
        vm.getEncomenda().destinatario.endereco.uf = item.estado;

        vm.atualizarDestinatarioEtiqueta();

        vm.showSedex10Message = false;

        Pedido.obterOpcoes(vm.getEncomenda().destinatario.endereco.cep.replace('-', ''))
          .then(function(tiposEntrega) {
            vm.podeEscolherFormaEnvio = true;
            vm.indicadorPrecoMaximo = tiposEntrega.inidicadorPrecoMaximo;
            vm.mensagemPostagem = tiposEntrega.mensagemPostagem;
            vm.observacao = tiposEntrega.observacao;
            vm.atualizaTipoEntrega(tiposEntrega.opcoes);
          })
          .catch(function(err) {
            vm.exibeErroBuscaServicos = true;
          });

      }

    };

    vm.showNF = function(servicoEnvio) {
      if (servicoEnvio) {
        if ((servicoEnvio == 'CartaRegistrada') || (servicoEnvio == 'Sedex10')) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    };

    vm.criaCifroes = function(total, quantidadeDestacada) {
      if (total && quantidadeDestacada) {
        let retorno = '';
        if (quantidadeDestacada > 0) {
          retorno = retorno + '<font color="#BBBBBB">';
          for (let i = 0; i < quantidadeDestacada; i++) {
            retorno = retorno + "$";
          }
          retorno = retorno + '</font>';
        }

        return retorno;
      }
    };

    vm.submitDestinatario = function(formDestinatario) {
      if (formDestinatario.$valid) {

        formDestinatario.$submitted = false;

        vm.buscaTipoEntregaPorCep();
      }
    };

    vm.buscaTipoEntregaPorCep = function(edit) {
      if (vm.tiposEntrega && !edit) {

        vm.podeAdicionarRemessa = true;
        vm.podeEscolherFormaEnvio = false;
        vm.buscaTipoServico = false;

      } else {
        vm.buscaTipoServico = true;
        Pedido.obterOpcoes(vm.getEncomenda().destinatario.endereco.cep.replace('-', ''))
          .then(function(tiposEntrega) {
            vm.indicadorPrecoMaximo = tiposEntrega.inidicadorPrecoMaximo;
            vm.mensagemPostagem = tiposEntrega.mensagemPostagem;
            vm.observacao = tiposEntrega.observacao;

            vm.atualizaTipoEntrega(tiposEntrega.opcoes);
            const servico = $filter('filter')(tiposEntrega.opcoes, {
              codigo: 'MandaeExpress'
            }, true)[0];
            vm.defineValoresDeclaradosPadrao(servico);
            vm.changeValorDeclarado();
            vm.definirValorDeclarado(vm.getEncomenda().valorDeclarado);

            vm.podeAdicionarRemessa = true;
            vm.podeEscolherFormaEnvio = false;

            vm.buscaTipoServico = false;
          })
          .catch(function(err) {
            vm.tratarErrosBackEnd(err);
            vm.exibeLoadingNovaBusca = false;
          });
      }

    };

    vm.atualizaTipoEntrega = function(tiposEntrega) {
      const mandaeExpress = $filter('filter')(tiposEntrega, {
        codigo: 'MandaeExpress'
      }, true)[0];

      // usuario pode utilizar nova Serviço de envio.
      if (mandaeExpress) {

        if (mandaeExpress.prazoConhecido === false) {
          // nao conseguiu buscar prazos nos correios
          vm.servicoSemPrazo = true;
        } else {
          vm.servicoSemPrazo = false;
        }

      } else {

        const pac = $filter('filter')(tiposEntrega, {
          codigo: 'Pac'
        }, true)[0];

        if (pac.prazoConhecido === false) {
          // nao conseguiu buscar prazos nos correios
          vm.servicoSemPrazo = true;
        } else {
          vm.servicoSemPrazo = false;
        }
      }

      if (vm.isEdicao) {
        vm.desejaContratarSeguro = {
          value: getActivation()
        };
        // Se está editando a encomenda.
        const sedex10 = $filter('filter')(tiposEntrega, {
          codigo: 'Sedex10'
        }, true)[0];

        // Verifica se não retornou o serviço sedex10 e se a encomenda está com sedex10. Adiciona o sedex10 na lista.
        // Se não retornou o serviço sedex10 e se o prazo foi retornado. Mostra mensagem dizendo que não possui sedex10.
        // Senão, apaga mensagem anterior.
        if (sedex10 == null && vm.getEncomenda().servicoEnvio == 'Sedex10') {

          const servicoEscolhido = {
            codigo: vm.getEncomenda().servicoEnvio,
            nomeExibicao: vm.getEncomenda().nomeExibicaoServicoEnvio,
            nomeFormatado: vm.getEncomenda().nomeExibicaoServicoEnvio
          }

          tiposEntrega.unshift(servicoEscolhido);
        } else if (sedex10 == null && !vm.servicoSemPrazo) {
          vm.showSedex10Message = true;
        } else {
          vm.showSedex10Message = false;
        }

        vm.checkNaoQueroEconomizar.value = vm.getEncomenda().mandaeEscolhe != null && !vm.getEncomenda().mandaeEscolhe;

      } else {
        // Se é uma adição de encomenda e se o prazo é conhecido.
        if (!vm.servicoSemPrazo) {
          const sedex10 = $filter('filter')(tiposEntrega, {
            codigo: 'Sedex10'
          }, true)[0];
          // Se não retornou o serviço sedex10. Mostra mensagem dizendo que não possui sedex10.
          // Senão, apaga mensagem anterior.
          if (sedex10 == null) {
            vm.showSedex10Message = true;
            //tiposEntrega.unshift({codigo: 'X', nomeFormatado: 'SEDEX-10 não disponível para esse CEP', disabled: true})
          } else {
            vm.showSedex10Message = false;
          }
        }
      }

      tiposEntrega.forEach(function(tipo) {
        if(tipo.nomeFormatado.indexOf('(') > 0)
          tipo.nomeFormatado = tipo.nomeFormatado.substring(0,  tipo.nomeFormatado.indexOf('(')) + 'após a postagem';
      });
      vm.tiposEntrega = tiposEntrega;
    };

    vm.novaBuscaTipoEntregaPorCep = function() {
      // vm.exibeLoadingNovaBusca = true; // Removido: loading visual desabilitado
      vm.buscaTipoEntregaPorCep(true);
      vm.exibeErroBuscaServicos = false;
    };


    vm.showTour = function() {
      if (_.isUndefined(showTourTelefone)) {
        showTourTelefone = new Tour({
          name: 'tourTelefoneReferencia',
          steps: [{
            element: ".telefone-destinatario",
            title: 'Dica!',
            content: "",
            placement: 'right',
            template: "<div class='popover tour tour-total tour-confirmacao'><div class='arrow'></div><h3 class='popover-title text-purple'></h3><div class='popover-content'></div><div class='content-custom'>Informe o telefone do destinatário. A transportadora poderá entrar em contato diretamente com ele para garantir a entrega.</div><button class='btn btn-success btn-tour' data-role='end'>Entendi</button></div>"
          }],
          backdrop: true,
          orphan: ".telefone-destinatario",
        });

        showTourTelefone.init();
        showTourTelefone.start();
      }
    };

    vm.escolheModalAdicionar = function(formModoEnvioNew, formDestinatario) {
      if (formModoEnvioNew.$valid) {

        if (vm.checkTenhoNF.value && !banirAlert('checkAlertNFCheck')) {
          // submete o formDestinatario para que possa validar os campos dele, em caso de ediçao.
          formDestinatario.$submitted = true;
          if (formDestinatario.$valid) {
            openModalNFCheck(formModoEnvioNew, formDestinatario);
          } else {
            $("html, body").animate({ scrollTop: 0 }, 500);
          }
        } else {
          adicionarRemessaNew(formModoEnvioNew, formDestinatario);
        }

      }
    };

    $rootScope.$on('adicionar:encomenda', function(event, formModoEnvioNew, formDestinatario) {
      adicionarRemessaNew(formModoEnvioNew, formDestinatario)
    });

    function adicionarRemessaNew(formModoEnvioNew, formDestinatario) {
      // vm.exibeLoadingNovaBusca = true; // Removido: loading visual desabilitado

      // submete o formDestinatario para que possa validar os campos dele, em caso de ediçao.
      formDestinatario.$submitted = true;

      if (formModoEnvioNew.$valid && formDestinatario.$valid) {
        // impedir que apareça o erro de cpf obrigatorio quando usou cnpj,
        // pois o model usado no input eh o cpf e anulamos ele nesse caso.
        //formModoEnvioNew.$submitted = false;

        // se usou cpf.
        if (vm.getEncomenda().destinatario.cpf) {
          // Pega o cpf ou cnpj.
          const cpf = vm.getEncomenda().destinatario.cpf.length == 11 ? vm.getEncomenda().destinatario.cpf : null;
          const cnpj = vm.getEncomenda().destinatario.cpf.length == 14 ? vm.getEncomenda().destinatario.cpf : null;

          if (cpf) {
            vm.getEncomenda().destinatario.tipoPessoa = 'fisica';
            vm.getEncomenda().destinatario.inscricaoEstadual = null;
          } else {
            vm.getEncomenda().destinatario.tipoPessoa = 'juridica';
          }

          vm.getEncomenda().destinatario.cpf = cpf;
          vm.getEncomenda().destinatario.cnpj = cnpj;
        }

        // seta email destintario
        vm.getEncomenda().destinatario.email = vm.getEncomenda().destinatario.email ? vm.getEncomenda().destinatario.email : null;

        // define o Tipo Documento origem.
        vm.getEncomenda().tipoDocumentoOrigem = defineTipoDocumentoOrigem();


        // define se mandae escolhe ou nao.
        vm.getEncomenda().mandaeEscolhe = defineSeMandaeEscolhe();

        // se simulou preço, define peso, dimensoes e valor na encomenda.
        if (vm.dadosSimulacao) {
          definePesoDimensoesValor();
        }

        const normalApresentado = $filter('filter')(vm.tiposEntrega, {
          codigo: 'MandaeNormal'
        }, true)[0];

        if (vm.getEncomenda().id) {
          $scope.$emit('pedido:encomenda:alterar', vm.getEncomenda());
        } else {
          $scope.$emit('pedido:encomenda:adicionar', vm.getEncomenda(), vm.dadosSimulacao ? vm.dadosSimulacao.desconto : null, !vm.checkNaoQueroEconomizar.value, normalApresentado ? true : false);
        }
      }
    }

    function definePesoDimensoesValor() {
      vm.getEncomenda().pesoOrcamento = vm.dadosSimulacao.peso;
      vm.getEncomenda().comprimentoOrcamento = vm.dadosSimulacao.comprimento;
      vm.getEncomenda().alturaOrcamento = vm.dadosSimulacao.altura;
      vm.getEncomenda().larguraOrcamento = vm.dadosSimulacao.largura;

      // se tem custo simulado no servico, usa no preco da encomenda.
      const servicoSimulado = $filter('filter')(vm.tiposEntrega, {
        codigo: vm.getEncomenda().servicoEnvio
      }, true)[0];

      if (servicoSimulado) {
        vm.getEncomenda().valorOrcamento = servicoSimulado.custo ? servicoSimulado.custo : null;
      }
    }

    function defineSeMandaeEscolhe() {
      // se 'nao quero economizar' esta desmarcado.
      const mandaeEscolhe = !vm.checkNaoQueroEconomizar.value;

      // se TEX devolve true ou false, senao NULL;
      if (vm.getEncomenda().servicoEnvio != 'CartaRegistrada' && vm.getEncomenda().servicoEnvio != 'Sedex10') {
        return mandaeEscolhe;
      } else {
        return null;
      }
    }

    function defineTipoDocumentoOrigem() {
      if (vm.checkTenhoNF.value) {
        return 'NFe';
      } else {
        return 'Minuta';
      }
    }

    /** FINAL TOTAL EXPRESS **/

    vm.changeCep = function(formDestinatario, formModoEnvioNew) {
      vm.isCepPreenchido = false;
      anulaEndereco();
      anulaFormaEnvio();
      anulaOutros();
      anulaServicosAdicionais();

      // Se formDestinatario foi submetido, coloco como não submetido
      // para não mostrar mensagens de validação.
      formDestinatario.$submitted = false;

      /*// Se formEndereco foi submetido, coloco como não submetido
      // para não mostrar mensagens de validação.
      formEndereco.$submitted = false;*/

      // Se formModoEnvioNew foi submetido, coloco como não submetido
      // para não mostrar mensagens de validação.
      formModoEnvioNew.$submitted = false;

      vm.podeEscolherFormaEnvio = false;
      vm.podeAdicionarRemessa = false;
      vm.utilizarServicoOpcional = false;
      vm.checkTenhoNF.value = vm.freedom ? true : null;
      vm.checkNaoQueroEconomizar.value = null;
      $rootScope.$broadcast('etiqueta:formaEnvio:alterada', null);

      $rootScope.$broadcast('etiqueta:destinatario:alterado', null);

      // Se alterou o cep, apaga mensagem de alterou cep correio
      vm.alterouEnderecoCorreios = false;

      // anula dados da simulaçao anterior.
      vm.dadosSimulacao = null;
      vm.dadosSimulacaoFormatado = null;
    };

    /**
     * Ao alterar os dados do endereço retornado pelos Correios,
     * exibe mensagem ao usuário.
     */
    vm.changeEnderecoCorreios = function() {
      if (enderecoCorreios.logradouro &&
        vm.getEncomenda().destinatario.endereco.logradouro !=
        enderecoCorreios.logradouro) {
        vm.alterouEnderecoCorreios = true;
      } else if (enderecoCorreios.bairro &&
        vm.getEncomenda().destinatario.endereco.bairro !=
        enderecoCorreios.bairro) {
        vm.alterouEnderecoCorreios = true;
      } else {
        vm.alterouEnderecoCorreios = false;
      }
    };

    vm.showServicosAdicionais = function() {
      vm.utilizarServicoOpcional = !vm.utilizarServicoOpcional;
      if (!vm.utilizarServicoOpcional) {
        anulaServicosAdicionais();
      }
    };

    vm.atualizarDestinatarioEtiqueta = function() {
      $rootScope.$broadcast('etiqueta:destinatario:alterado', vm.getEncomenda().destinatario);
    };

    vm.atualizarImagemServico = function() {
      $rootScope.$broadcast('etiqueta:formaEnvio:alterada', vm.getEncomenda().servicoEnvio);
    };



    function preencherValoresSimulacao(simulacoes) {

      // chama essa function para anular custo do sedex10,
      // pois se foi simulado antes mantem o valor.
      anulaCusto('Sedex10');
      anulaCusto('MandaeNormal');
      const opcoes = simulacoes.opcoes;
      for (const i in opcoes) {
        if (opcoes[i].codigo) {
          const servicoSimulado = $filter('filter')(vm.tiposEntrega, {
            codigo: opcoes[i].codigo
          }, true)[0];

          if (servicoSimulado) {
            servicoSimulado.custo = opcoes[i].preco;
          }
        }
      }

      // verifica se o peso ultrapassou os 10 kg do Sedex10.
      verificaSePesoAtendeSedex10();
    }

    function anulaCusto(servico) {
      const servicoAnulado = $filter('filter')(vm.tiposEntrega, {
        codigo: servico
      }, true)[0];

      if (servicoAnulado) {
        servicoAnulado.custo = null;
        servicoAnulado.medidaIndisponivel = null;
      }
    };

    function verificaSePesoAtendeSedex10() {
      const servicoSedex10 = $filter('filter')(vm.tiposEntrega, {
        codigo: 'Sedex10'
      }, true)[0];

      if (servicoSedex10 && (servicoSedex10.custo === null || servicoSedex10.custo === 0)) {
        servicoSedex10.medidaIndisponivel = true;
      }
    }

    vm.calculaValorDeclaradoAdicional = function(valorDeclarado) {
      const adicional = (vm.taxaValorDeclarado / 100) * valorDeclarado;
      return adicional > 0 ? adicional : 0;
    }

    vm.changeValorDeclarado = function() {
      if (vm.valorDeclaradoMaximo) {
          vm.valorDeclaradoAdicional = vm.calculaValorDeclaradoAdicional(vm.getEncomenda().valorDeclarado);
      }
    };

    vm.clearChaveAcessoNFe = function() {
      vm.getEncomenda().chaveAcessoNFe = vm.getEncomenda().chaveAcessoNFe.replace(/\D/g,'');
    };

    // Função para limpar erros do backend (preserva estado do formulário)
    vm.clearBackendErrors = function() {
      vm.backendErrors = [];
    };

    // Função chamada quando o usuário faz mudanças no formulário (limpa erros automaticamente)
    vm.onFormChange = function() {
      if (vm.backendErrors && vm.backendErrors.length > 0) {
        vm.clearBackendErrors();
      }
    };

    function anulaServicosAdicionais() {
      vm.getEncomenda().referencia = null;
      vm.getEncomenda().qrCodes = null;
    };

    function anulaFormaEnvio() {
      vm.getEncomenda().servicoEnvio = '';
      vm.getEncomenda().nomeExibicaoServicoEnvio = '';
    };

    function anulaOutros() {
      vm.getEncomenda().observacao = null;
      vm.getEncomenda().destinatario.cpf = null;
      vm.getEncomenda().destinatario.nome = null;
      vm.getEncomenda().destinatario.email = null;
    };

    function anulaEndereco() {
      vm.getEncomenda().destinatario.endereco = null;
    };

    vm.tratarErrosBackEnd = function(err) {
      // Ajuste: esconder barra de loading/scroll e mostrar apenas mensagens dentro de err.data.erros
      vm.exibeLoadingNovaBusca = false;
      $timeout(function() {
        try {
          vm.backendErrors = [];
          if (err && err.data && err.data.erros) {
            const erros = err.data.erros;
            Object.keys(erros).forEach(function(k) {
              vm.backendErrors.push(erros[k]);
            });
          } else if (err && err.data && err.data.erro) {
            vm.backendErrors.push(err.data.erro);
          }
          // Scroll para o topo para exibir as mensagens claramente e manter o estado do formulário
          $("html, body").animate({ scrollTop: 0 }, 300);
        } catch (e) {
          $log.error('Falha ao tratar erros de backend', e);
        }
      });
    };

    // Escutar eventos de erro do controller pai
    $scope.$on('pedido:encomenda:erro', function(event, err) {
      vm.tratarErrosBackEnd(err);
    });

    /** TOTAL EXPRESS **/
    vm.ehPessoaJuridica = function() {
      return vm.getEncomenda().destinatario != null && vm.getEncomenda().destinatario.cpf != null && vm.getEncomenda().destinatario.cpf.length == 14;
    }

    vm.setServico = function(servico) {

      vm.naoDesabilita = false;

      if (vm.getEncomenda().servicoEnvio == '') {
        angular.element('.box-nota-fiscal').removeClass('animate-text');
      }

      $("html, body").animate({ scrollTop: $(document).height() }, 500);

      vm.getEncomenda().servicoEnvio = servico.codigo;
      vm.getEncomenda().prazoMaximo = servico.prazoMaximo;
      vm.getEncomenda().prazoMinimo = servico.prazoMinimo;
      vm.atualizarImagemServico();

      vm.defineValoresDeclaradosPadrao(servico);
      vm.changeValorDeclarado();
    }

    vm.resetValorDeclarado = function () {
      vm.getEncomenda().valorDeclarado = null;
      vm.changeValorDeclarado();
    }

    vm.buscaNomeExibicao = function (nome) {
      return _.find(vm.tiposEntrega, function(o){
          return o.codigo === nome;
      })
    }

    vm.defineValoresDeclaradosPadrao = function(servico) {
      vm.taxaValorDeclarado = servico.percentualValorDeclarado;
      vm.valorDeclaradoMinimo = servico.valorDeclaradoMinimo;
      vm.valorDeclaradoMaximo = servico.valorDeclaradoMaximo;
      vm.valorDeclaradoNomeExibicao = servico.nomeExibicao;
    }


    vm.definirValorDeclarado = function(valor) {
      vm.getEncomenda().valorDeclarado = valor === 0 ? valor = null : valor;

      if (valor == null && vm.getEncomenda().servicoEnvio == 'CartaRegistrada') {
        // valor nulo e Carta, nao mostra Outros valores.
        vm.showOutrosValores = false;
      } else if (valor === null || valor === 0) {
        vm.valorDeclaradoAdicional = null;
        vm.showOutrosValores = true;
        $timeout(function() {
          angular.element('.outro-valor').focus();
        });
      } else {
        vm.showOutrosValores = true;
      }
    }

    function isAlgumValorPadrao(valor) {
      return valor != null && vm.listaValorDeclaradoPadrao.indexOf(valor) != -1;
    }

    vm.viewFormEndereco = function() {
      vm.podeAdicionarRemessa = false;
      vm.podeEscolherFormaEnvio = true;
      vm.isCepPreenchido = true;
      vm.utilizarServicoOpcional = false;
    }

    function banirAlert(alert) {
      return localStorageService.cookie.get(alert) != null;
    }

    vm.temPedidoAtivo = function() {
      return Pedido.temPedidoComRemessa();
    };

    //*------------------------ DISPARA MODAIS ---------------------------*//

    vm.openModalSaibaMaisTransportadoras = function() {
          $uibModal.open({
        animation: false,
        windowClass: 'modal-economizar',
        templateUrl: 'modalTransportadora.html',
        controller: 'ModalTransCtrl',
      });
    };

    vm.openModalNF = function() {
          $uibModal.open({
        animation: false,
        windowClass: 'modal-nf',
        templateUrl: 'modalNF.html',
        controller: 'ModalNFCtrl',
      });
    }

    vm.openModalSimulacaoPrecoCtrl = function() {
          $uibModal.open({
        animation: false,
        windowClass: 'modal-simulacao-preco',
        templateUrl: 'modalSimulacaoPrecoCtrl.html',
        controller: 'ModalSimulacaoPrecoCtrl',
        resolve: {
          dados: function() {
            return {
              cep: vm.getEncomenda().endereco.cep,
              tipoPessoa: Auth.isPJ() ? 'pj' : 'pf'
            };
          }
        }
      });

      modalInstance.result.then(function(retorno) {
        // Manusear tiposEntrega com os valores retornados pela simulacao.
        if (retorno.orcamentoRetorno) {
          preencherValoresSimulacao(retorno.orcamentoRetorno);
        }

        // dados da simulacao usado na tela - ajustado para múltiplos volumes
        if (retorno.isMultiVolume) {
          vm.dadosSimulacaoFormatado = retorno.volumes.length + ' volumes';
        } else if (retorno.dadosSimulacao) {
          vm.dadosSimulacaoFormatado = retorno.dadosSimulacao.peso + ' kg, ' +
            retorno.dadosSimulacao.comprimento + ' x ' +
            retorno.dadosSimulacao.largura + ' x ' +
            retorno.dadosSimulacao.altura + ' cm';
        }

        // dados da simulacao usado na encomenda a ser salva.
        vm.dadosSimulacao = retorno.dadosSimulacao || retorno.volumes;

      }, function() {
        $log.info('Modal dismissed at: ' + new Date());
      });
    }

    vm.openModalAtrasoCorreios = function() {
          $uibModal.open({
        animation: false,
        windowClass: 'modal-atraso',
        templateUrl: 'modalAtraso.html',
        controller: 'ModalAtrasoCtrl',
      });
    };

    function openModalNFCheck(formModoEnvioNew, formDestinatario) {
      if (formModoEnvioNew.$valid) {
          $uibModal.open({
          animation: false,
          windowClass: 'modal-nf-check',
          templateUrl: 'modalNFCheck.html',
          controller: 'ModalNFCheckCtrl',
          resolve: {
            formModoEnvioNew: formModoEnvioNew,
            formDestinatario: formDestinatario
          }
        });
      }
    };

    vm.openModalTex = function() {

      if (!banirAlert('checkAlertTex')) {
          $uibModal.open({
          animation: false,
          windowClass: 'modal-tex',
          templateUrl: 'modalTex.html',
          controller: 'ModalTexCtrl',
        });

        // Abre este popup somente na primeira vez.
        //localStorageService.cookie.set('checkAlertTex', true);
      }
      //}
    }

    vm.openModalNaoEconomizar = function() {
      if (vm.checkNaoQueroEconomizar.value &&
        !banirAlert('checkAlertNaoEconomizar')) {
          $uibModal.open({
          animation: false,
          windowClass: 'modal-economizar',
          templateUrl: 'modalEconomizar.html',
          controller: 'ModalEconomizarCtrl'
        }).result.then(function(result) {
          vm.checkNaoQueroEconomizar.value = result;
        });
      }
    }

  };

  /* ------------- CONTROLLERS MODAIS ------------------ */

  // modal nota fiscal
  function ModalNFCtrl($uibModalInstance, $scope) {

    $scope.ok = function() {
      $uibModalInstance.dismiss('cancel');
    };
  };

  // modal nota fiscal check
  function ModalNFCheckCtrl($rootScope, $scope, $uibModalInstance, formModoEnvioNew, formDestinatario, localStorageService) {

    $scope.checkboxModel = {
      nf: false
    };

    $scope.voltar = function() {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.dontShowAgain = function(alert) {
      if (localStorageService.cookie.get(alert) == null) {
        localStorageService.cookie.set(alert, true);
      } else if (localStorageService.cookie.get(alert) === true) {
        localStorageService.cookie.remove(alert);
      }
    }

    $scope.entendi = function() {
      $uibModalInstance.dismiss('cancel');
      $rootScope.$broadcast('adicionar:encomenda', formModoEnvioNew, formDestinatario);
    };
  };

  // modal tex
  function ModalTransCtrl($uibModalInstance, $scope, $uibModal, localStorageService, Auth) {

    $scope.isPJ = Auth.isPJ();

    $scope.abreFecha = function() {
      $uibModalInstance.dismiss('cancel');
          $uibModal.open({
        animation: false,
        windowClass: 'modal-nf',
        templateUrl: 'modalNF.html',
        controller: 'ModalNFCtrl',
      });
    };

    $scope.checkboxModel = {
      tex: false
    };

    $scope.dontShowAgain = function(alert) {
      if (localStorageService.cookie.get(alert) == null) {
        localStorageService.cookie.set(alert, true);
      } else if (localStorageService.cookie.get(alert) === true) {
        localStorageService.cookie.remove(alert);
      }
    }

    $scope.ok = function() {
      $uibModalInstance.dismiss('cancel');
    }
  };

  // modal não quero economizar
  function ModalEconomizarCtrl($scope, $uibModalInstance, localStorageService) {

    $scope.checkboxModel = {
      economizar: false
    };

    $scope.dontShowAgain = function(alert) {
      if (localStorageService.cookie.get(alert) == null) {
        localStorageService.cookie.set(alert, true);
      } else if (localStorageService.cookie.get(alert) === true) {
        localStorageService.cookie.remove(alert);
      }
    }

    $scope.naoQuero = function() {
      $uibModalInstance.dismiss('cancel');
    }

    $scope.queroSim = function() {
      $uibModalInstance.close(false);
    }

  };

  // modal atraso fim de ano
  function ModalAtrasoCtrl($uibModalInstance) {

    $scope.ok = function() {
      $uibModalInstance.dismiss('cancel');
    };
  };

  // modal simulacao preço - Atualizado para usar componente Angular
  function ModalSimulacaoPrecoCtrl($uibModalInstance, $scope, $log, $filter, Orcamento, Pedido, dados) {

    $scope.retorno = {};
    $scope.cepDestino = dados.cep;
    $scope.tipoPessoa = dados.tipoPessoa;
    $scope.mostrarResultados = false;

    // Callback do componente Angular quando simulação é feita
    $scope.onSimular = function(dadosSimulacao) {
      $scope.exibeLoadingSimulacao = true;

      // Simular com cada volume individualmente e agregar resultados
      var promessasSimulacao = dadosSimulacao.volumes.map(function(volume) {
        var dadosEntrada = {};
        dadosEntrada.cepDestino = $scope.cepDestino;
        dadosEntrada.pj = $scope.tipoPessoa;
        dadosEntrada.peso = volume.peso;
        dadosEntrada.comprimento = parseFloat(volume.comprimento) || 0.1;
        dadosEntrada.largura = parseFloat(volume.largura) || 0.1;
        dadosEntrada.altura = parseFloat(volume.altura) || 0.1;

        return Pedido.obterOpcoesComPreco(dadosEntrada);
      });

      // Executa todas as simulações de orçamento em paralelo e exibe o resultado consolidado
      Promise.all(promessasSimulacao)
        .then(function(resultados) {
          $scope.exibeLoadingSimulacao = false;
          $scope.retorno.orcamentoRetorno = consolidarOrcamentos(resultados);
          $scope.retorno.volumes = dadosSimulacao.volumes;
          $scope.retorno.isMultiVolume = dadosSimulacao.isMultiVolume;
          $scope.mostrarResultados = true;
          $scope.$apply();
        })
        .catch(function(err) {
          $scope.exibeLoadingSimulacao = false;
          $log.error('Erro ao buscar orçamento:', err);
          $scope.$apply();
        });
    };

    // Função para consolidar orçamentos de múltiplos volumes
    function consolidarOrcamentos(resultados) {
      if (!resultados || resultados.length === 0) return null;

      var baseOrcamento = resultados[0];

      if (resultados.length === 1) {
        return baseOrcamento;
      }

      // Para múltiplos volumes, somar os custos
      var opcoes = baseOrcamento.opcoes.map(function(opcaoBase) {
        var custoTotal = opcaoBase.custo.valor;
        var prazoMaximo = opcaoBase.prazo;

        // Somar custos de todos os volumes para esta opção
        for (var i = 1; i < resultados.length; i++) {
          var opcaoCorrespondente = resultados[i].opcoes.find(function(opt) {
            return opt.codigo === opcaoBase.codigo;
          });

          if (opcaoCorrespondente && opcaoCorrespondente.disponivel) {
            custoTotal += opcaoCorrespondente.custo.valor;
            prazoMaximo = Math.max(prazoMaximo, opcaoCorrespondente.prazo);
          }
        }

        return {
          codigo: opcaoBase.codigo,
          nome: opcaoBase.nome,
          disponivel: opcaoBase.disponivel,
          custo: { valor: custoTotal },
          prazo: prazoMaximo,
          medidaIndisponivel: opcaoBase.medidaIndisponivel
        };
      });

      return {
        opcoes: opcoes
      };
    }

    $scope.extraiPrecoOrcamento = function(orcamento, codigoServico) {
      var orcamentoServico = $filter('filter')(orcamento.opcoes, {
        codigo: codigoServico
      }, true)[0];

      return orcamentoServico ? orcamentoServico.preco : null;
    };

    $scope.selecionarOpcao = function(opcao, retorno) {
      var data = {};
      data.opcao = opcao;
      data.dadosSimulacao = retorno.dadosSimulacao;
      data.volumes = retorno.volumes;
      data.isMultiVolume = retorno.isMultiVolume;
      $uibModalInstance.close(data);
    };

    $scope.voltarParaSimulacao = function() {
      $scope.mostrarResultados = false;
      $scope.retorno = {};
    };

    $scope.voltar = function() {
      $uibModalInstance.dismiss('cancel');
    };

  };

  // modal em breve
  function ModalEmBreveCtrl($scope, $uibModalInstance, Encomenda) {

    var vmEmBreve = this;

    vmEmBreve.areaLiberada = null;
    vmEmBreve.areaNaoLiberada = null;

    vmEmBreve.clear = function() {
      vmEmBreve.areaLiberada = null;
      vmEmBreve.areaNaoLiberada = null;
      vmEmBreve.endereco = null;
    };

    vmEmBreve.preencheEndereco = function(item, model, label, event) {

      Encomenda.verificarArea(item.cep)
        .then(function(area) {
          area.areaAtendimento ? vmEmBreve.areaLiberada = true : vmEmBreve.areaNaoLiberada = true;
        })
        .catch(function(err) {
          console.log('nao foi')

        });
    };

    vmEmBreve.ok = function() {
      $uibModalInstance.dismiss('cancel');
    };
  };

  function ModalMercadoLivreCtrl($uibModalInstance, primeiraVez, localStorageService) {

    var vmML = this;

    vmML.calc = {};
    vmML.tamanho = null;
    // controla exibição de conteúdo para modal de 2 steps
    vmML.primeiraVez = primeiraVez;
    vmML.step2 = false;


    vmML.isValidDimensoes = function() {
      var somaMedidas = vmML.calc.altura + vmML.calc.largura + vmML.calc.comprimento;
      if (somaMedidas > 200) {
        return false;
      }

      return true;
    };

    vmML.showPrecos = function() {
      vmML.primeiraVez = false;
      vmML.step2 = true;
    };

    vmML.continuar = function() {
      localStorageService.cookie.set('primeiraVezML', true);
      $uibModalInstance.close();
    };

    vmML.calcularTamanhoCaixa = function(dadosTamanhoCaixa) {

      if (dadosTamanhoCaixa.$valid) {
        vmML.tamanho = null;
        var cmCubicos = vmML.calc.comprimento * vmML.calc.altura * vmML.calc.largura;
        if (cmCubicos < 25000) {
          vmML.tamanho = 'pequeno até 25.000';
        } else if (cmCubicos < 50000) {
          vmML.tamanho = 'médio até 50.000';
        } else {
          vmML.tamanho = 'grande até 150.000';
        }
      }
    };

    vmML.fechar = function() {
      $uibModalInstance.dismiss('cancel');
    };
  };

  angular.module('mandaeApp')
    .controller('EncomendaCtrl', EncomendaCtrl)
    .controller('ModalNFCtrl', ModalNFCtrl)
    .controller('ModalNFCheckCtrl', ModalNFCheckCtrl)
    .controller('ModalTransCtrl', ModalTransCtrl)
    .controller('ModalEconomizarCtrl', ModalEconomizarCtrl)
    .controller('ModalAtrasoCtrl', ModalAtrasoCtrl)
    .controller('ModalSimulacaoPrecoCtrl', ModalSimulacaoPrecoCtrl)
    .controller('ModalEmBreveCtrl', ModalEmBreveCtrl)
    .controller('ModalMercadoLivreCtrl', ModalMercadoLivreCtrl);
})();
